(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-alphabetical-filter"] && !Shopify.designMode) return;
  try {
    
  window.onLetterClicked = function (event) {
    var button = event.target;
    var letter = button.getAttribute('data-letter');
    var target = document.getElementById('letter-heading-' + letter);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' })
    }
  };

  $(document).ready(function() {
    $('.letter-result-container a').hover(function() {
      var imgUrl = $(this).attr('data-img');
      var link = $(this).attr('href');
      var imgPreviewLink = $(".alphabet-section-img-preview");
      var previewImg = $(".alphabet-section-img-preview img");

      imgPreviewLink.attr('href', link)      ;
      previewImg.attr('src', imgUrl)
    })
  })

  } catch(e) { console.error(e); }
})();
})();
